import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { SalesFunnelDataService } from '../shared/sales-funnel-data.service';
import { ISalesFunnelLayoutChild } from '../shared/sales-funnel-child.module';
import { OpportunitiesBtnComponent } from '../shared/opportunities-btn/opportunities-btn.component';

interface Lead {
  id: string;
  address: string;
  postcode: string;
  people: number;
  value: string;
  status: string;
  priority: string;
  phone?: string;
}

@Component({
  selector: 'app-sales-funnel',
  standalone: true,
  imports: [FormsModule, OpportunitiesBtnComponent],
  templateUrl: './sales-funnel-component.html',
  styleUrls: ['./sales-funnel-component.scss']
})
export class SalesFunnelComponent implements OnInit, ISalesFunnelLayoutChild {
  private router = inject(Router);
  private dataService = inject(SalesFunnelDataService);

  searchQuery = '';
  sortBy = 'voucher';
  filterStatus = '';
  selectedLead: Lead | null = null;
  salesFunnelIndex = 0;

  leads: Lead[] = [
    {
      id: '1',
      address: '8 Somerton Road',
      postcode: 'OX25 5LG',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority',
      phone: '+441869347001'
    },
    {
      id: '2',
      address: '22 Station Road',
      postcode: '+441869347005',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '3',
      address: '45 High Street',
      postcode: 'OX15 0SH',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '4',
      address: '12 Market Place',
      postcode: 'OX15 0SJ',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '5',
      address: '7 Castle Street',
      postcode: 'OX15 0SK',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '6',
      address: '33 Oxford Road',
      postcode: 'OX5 1AA',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '7',
      address: '18 The Moors',
      postcode: 'OX5 1AB',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '8',
      address: '9 Mill Street',
      postcode: 'OX5 1AC',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '9',
      address: '56 High Street',
      postcode: 'OX5 1AD',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '10',
      address: '14 Market Square',
      postcode: 'OX20 1TA',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '11',
      address: '27 Park Street',
      postcode: 'OX20 1TB',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '12',
      address: '41 Oxford Street',
      postcode: 'OX20 1TC',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '13',
      address: '8 Hensington Road',
      postcode: 'OX20 1TD',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '14',
      address: '52 Cornmarket Street',
      postcode: 'OX26 6AA',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '15',
      address: '19 Market Square',
      postcode: 'OX26 6AB',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '16',
      address: '35 Sheep Street',
      postcode: 'OX26 6AC',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '17',
      address: '63 King\'s End',
      postcode: 'OX26 6AD',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '18',
      address: '28 Field Street',
      postcode: 'OX26 6AE',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '19',
      address: '74 London Road',
      postcode: 'OX26 6AF',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    },
    {
      id: '20',
      address: '11 Victoria Road',
      postcode: 'OX26 6AG',
      people: 2,
      value: '£800',
      status: 'new',
      priority: 'low priority'
    }
  ];

  filteredLeads: Lead[] = [];

  ngOnInit(): void {
    this.filteredLeads = [...this.leads];
  }

  filterLeads(): void {
    let filtered = [...this.leads];

    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase();
      filtered = filtered.filter(lead =>
        lead.address.toLowerCase().includes(query) ||
        lead.postcode.toLowerCase().includes(query)
      );
    }

    if (this.filterStatus) {
      filtered = filtered.filter(lead => lead.status === this.filterStatus);
    }

    this.filteredLeads = filtered;
  }

  sortLeads(): void {
    if (this.sortBy === 'voucher') {
      this.filteredLeads.sort((a, b) => {
        const valueA = parseInt(a.value.replace('£', ''));
        const valueB = parseInt(b.value.replace('£', ''));
        return valueB - valueA;
      });
    } else if (this.sortBy === 'address') {
      this.filteredLeads.sort((a, b) => a.address.localeCompare(b.address));
    } else if (this.sortBy === 'people') {
      this.filteredLeads.sort((a, b) => b.people - a.people);
    }
  }

  selectLead(lead: Lead): void {
    this.selectedLead = lead;
  }

  goToEligibility(): void {
    if (this.selectedLead) {
      this.dataService.updateLead(this.selectedLead);
      this.router.navigate(['/package-offer']);
    }
  }


openMap(lead: Lead): void {
  this.router.navigate(['/map'], {
    queryParams: {
      address: lead.address,
      postcode: lead.postcode
    }
  });
}

}
